export default __webpack_public_path__ + "static/media/onegai.09559e34.png";